export default __webpack_public_path__ + "static/media/overview.8ba47bb7.svg";